export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11885.fa19dbe2.jpg";